import React from 'react';
import { useIntl } from 'react-intl';
import LinkAndAnchor from '../LinkAndAnchor';
import getMarketBreadcrumbs from '../Market/getBreadcrumbs';
import messages from '../../lib/messages';

const Breadcrumbs = ({ marketName, marketId }) => {
  const intl = useIntl();

  return (
    [
      ...getMarketBreadcrumbs({ marketName, marketId }),
      <LinkAndAnchor
        route="stands"
        params={{ marketId }}
      >
        {intl.formatMessage(messages.stands)}
      </LinkAndAnchor>,
    ]
  );
};

export default Breadcrumbs;
